module.exports = __webpack_public_path__ + "static/media/banner-placeholder-full.f97d604c.png";